import React from 'react';
import Image from 'react-bootstrap/Image';
import sweden from '../../../images/sweden (1).png';

function SwedenImage() {
    
    return  <Image src={sweden} fluid alt="cart-ikon"/>;
    
}
export default SwedenImage;